/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { Fragment, useState } from "react";
import env from "../../../env";
import { Loading, ErrorPopup, usePost } from "../../../components";
import { useForm } from "../../../form";
import { ProductTile } from "./productTile";
import { tileListStyle } from "./productTileStyle";
import { getCategoryListModel } from "./categoryListModel";

export function ProductItems({ categories }) {
  const post = usePost();
  React.useEffect(() => {
    post.send(env.apiBase + "/api/product/getProducts", {
      categories: categories,
    });
    // eslint-disable-next-line
  }, [categories]);

  if (post.loading()) {
    return <Loading />;
  } else if (post.hasErrors()) {
    return <ErrorPopup title='Loading Error' errors={post.errors} />;
  }

  const data = post.response;

  const sortedData = data.items.filter((item) => item.productStatus !== 98);

  console.log("API Response Data:", data);

  return sortedData && sortedData.length > 0 ? (
    <Items items={sortedData} categories={data.categories} />
  ) : (
    <div>No products</div>
  );
}

function Items({ items, categories }) {
  const s = tileListStyle;
  const model = getCategoryListModel(categories);
  const categoryListForm = useForm(model, {
    usePlaceholder: true,
    onControlChanged: orderItemChanged,
  });

  const [showProducts, setShowProducts] = useState(() => {
    // Always set seqInCategory for all products based on their first category
    let _items = JSON.parse(JSON.stringify(items));
    
    _items.forEach((item) => {
      if (item.productCategories && item.productCategories.length > 0) {
        // Set seqInCategory from the first category
        item.seqInCategory = item.productCategories[0].seq;
      }
    });

    if (categories.length === 1) {
      // Filter by specific category
      _items = _items.filter((item) => {
        for (let i in item.productCategories) {
          if (
            item.productCategories[i].categoryId === categories[0].categoryId
          ) {
            item.seqInCategory = item.productCategories[i].seq;
            return true;
          }
        }
        return false;
      });
    }

    sortProudcts(_items);
    return _items;
  });

  function orderItemChanged(e, control) {
    if (control && control.name === "categoryList") {
      console.log("control value", control.value);
      let _items = [];
      
      if (control.value && control.value !== "") {
        _items = items.filter((item) => {
          if (control.value === "_favourites_") {
            if (localStorage.favorites !== "") {
              if (localStorage.favorites.includes(item.productId)) {
                return true;
              }
            }
          } else {
            for (let i in item.productCategories) {
              if (item.productCategories[i].categoryId === control.value) {
                item.seqInCategory = item.productCategories[i].seq;
                return true;
              }
            }
          }
          return false;
        });
      } else {
        _items = [...items]; // Create a copy to avoid mutating original
      }
      
      // Ensure all items have seqInCategory set
      _items.forEach((item) => {
        if (!item.seqInCategory && item.productCategories && item.productCategories.length > 0) {
          item.seqInCategory = item.productCategories[0].seq;
        }
      });
      
      // Sort the items
      sortProudcts(_items);
      setShowProducts(_items);
    }
  }

  const render = (name) => categoryListForm.renderControl(name, null);
  return (
    <Fragment>
      <div css={s.categoryList} className='product_cont'>
        {render("categoryList")}
      </div>
      <div css={s.tiles} className='product_cont'>
        {showProducts.length > 0 ? (
          showProducts.map((item, index) => (
            <ProductTile key={index} product={item} />
          ))
        ) : (
          <div style={{ margin: "auto" }}> No product </div>
        )}
      </div>
    </Fragment>
  );
}

function sortProudcts(items) {
  items.sort((a, b) => {
    // Handle cases where seqInCategory might be undefined
    const seqA = a.seqInCategory !== undefined ? a.seqInCategory : 999999;
    const seqB = b.seqInCategory !== undefined ? b.seqInCategory : 999999;
    
    // If both have the same sequence, sort by product name
    if (seqA === seqB) {
      return (a.productName || '').localeCompare(b.productName || '');
    }
    
    // Special handling: 0 should come first, then other numbers
    if (seqA === 0 && seqB !== 0) return -1;
    if (seqB === 0 && seqA !== 0) return 1;
    
    return seqA - seqB;
  });
}

// function sortProductsCategorySeq(items) {
//   items.sort((a, b) => {
//     return a.productCategories.seq - b.productCategories.seq;
//   });
// }
